// removed by extract-text-webpack-plugin
module.exports = {"root":"_1qPL4","head":"_34-FQ","name":"_2iru5","figure":"_1apEf","avatar":"_2GAFO","figureBlank":"OjDHt","subnav":"_1tb9C"};


//////////////////
// WEBPACK FOOTER
// ../source/components/AccountNav/styles.css
// module id = 1232
// module chunks = 26